import React from "react";
export const CaseStudiesImageCard = ({ image, title }) => (
  <div className="flex-1 w-full flex flex-col gap-3">
    <div className="w-full  rounded-[10px]  overflow-hidden">
      {image ? (
        <img
          src={image}
          alt={title || 'Case study image'}
          className="w-full  object-contain"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-[#31333A] text-gray-500">
          No Image Available
        </div>
      )}
    </div>
    <div className="w-full text-center text-[#949494]">
      {title || 'Title of the image goes over here'}
    </div>
  </div>
);


export const CaseStudyHeading = React.memo(({ title, desc }) => (
  <>
    {title && (
      <h2 className="text-left font-bold text-xl font-jakarta md:text-2xl text-[#FFFFFF]">
        {title}
      </h2>
    )}
    {desc && (
      <p className="text-[#D8D8D8] font-semibold font-jakarta max-w-[630px] text-[16px] md:text-[20px]">
        {desc}
      </p>
    )}
  </>
));

export const BackgroundWithCurve = ({
  image,
  overlayColor = 'bg-[#222429]',
  curveColor = '#121316',
  heightClasses = 'h-[470px] sm:h-[550px] md:h-[700px] lg:h-[750px] xl:h-[800px]',
}) => {
  return (
    <div className={`absolute top-0 left-0 right-0 ${heightClasses} z-0`}>
      <div className="relative w-full h-full overflow-hidden">
        {/* Background Image */}
        <img
          src={image}
          alt="Background"
          className="w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className={`absolute inset-0 ${overlayColor}`} />
      </div>

      {/* Curved Bottom */}
      <svg
        className="absolute -bottom-1 left-0 w-full h-[60px] sm:h-[70px] md:h-[80px] lg:h-[100px] xl:h-[120px]"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0,120 L0,0 Q720,120 1440,0 L1440,120 Z" fill={curveColor} />
      </svg>
    </div>
  );
};


const parseMarkdown = (text) => {
  if (typeof text !== 'string') return text;

  const parts = text.split(/(\*\*.*?\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={index} className="font-semibold text-white">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return part;
  });
};



export const Section = ({ title, subtitle, content }) => (
  <div className="flex flex-col gap-3">
    <CaseStudyHeading title={title} />
    {subtitle && (
      <h3 className="text-xl font-normal font-jakarta text-[#D8D8D8]">
        {subtitle}
      </h3>
    )}
    {Array.isArray(content) ? (
      content.map((paragraph, index) => (
        <p key={index} className="text-[#C8C8C8] font-normal">
          {parseMarkdown(paragraph)}
        </p>
      ))
    ) : (
      <p className="text-[#C8C8C8] font-normal">{parseMarkdown(content)}</p>
    )}
  </div>
);

export const BulletSection = ({
  title,
  subtitle,
  introText,
  bulletPoints,
  closingText,
}) => (
  <div className="flex flex-col gap-5">
    {(title || subtitle) && <CaseStudyHeading title={title} desc={subtitle} />}

    {/* Introductory Paragraph */}
    {introText && (
      <p className="text-[#C8C8C8] text-[16px] leading-relaxed">
        {parseMarkdown(introText)}
      </p>
    )}

    {/* Bullet List */}
    {bulletPoints && bulletPoints.length > 0 && (
      <ul className="list-disc list-inside text-[#C8C8C8] relative left-3 text-[16px] space-y-2 marker:text-[#FFFFFF]">
        {bulletPoints.map((point, index) => (
          <li key={index}>{parseMarkdown(point)}</li>
        ))}
      </ul>
    )}

    {/* Closing Description */}
    {closingText && (
      <p className="text-[#C8C8C8] text-[16px] leading-relaxed">
        {parseMarkdown(closingText)}
      </p>
    )}
  </div>
);


export const ImpactCard = ({ percentage, description }) => (
  <div className="rounded-[10px] p-4 h-[150px] md:h-[240px] w-full bg-[#232428] flex flex-col gap-2 justify-center items-center shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)]">
    <div className="text-[30px] md:text-[40px] lg:text-[50px] text-[#F5F5F5] font-questrial text-center">
      {percentage}
    </div>
    <div className="text-[14px] md:text-[16px] lg:text-[16px] text-center text-[#F5F5F5]">
      {description}
    </div>
  </div>
);